
import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'
import { WeveSelectField } from '@weve/ui'

import { Status } from '@/types'
import { STATUS_TO_DISPLAY_NAME } from '@/data'

const options = Object.values(Status).map((type) => ({
  value: type,
  label: STATUS_TO_DISPLAY_NAME[type],
}))

export default Vue.extend({
  name: 'StatusSelect',
  functional: true,
  render(h, { data, children }) {
    return h(
      WeveSelectField,
      mergeData(data, { props: { options, label: 'Status' } }),
      children
    )
  },
})
